// extracted by css-extract-rspack-plugin
export default {"nativeApplyModalButtonBlock":"RichTextNativeApplyModalButton_nativeApplyModalButtonBlock__uTbgZ"};